import type { FaireProductEntity } from "../../entity_types/product";

export const p_uzud4jb8t4: FaireProductEntity = {
  token: "p_uzud4jb8t4",
  type: "product",
  name: "Butter Dish with Lid 6.5\"L w/ Butter Knife Spring Bee Design (4/32)",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/491bb84b1e214e9de90b8af5b60d81700b354a6379e86e2998c3c8b4a1d809ad.png",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Size: 6.5\"L x 3.8\"W x 3\"H\n\nMaterial: Ceramic with Bamboo Lid\n\nCase Pack: 32\n\nOrigin: China\n",
  tags: [],
  msrpDollars: 22.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:37.745Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
